import { DialogTitle, Typography, styled, Box } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const DialogTitleCustom = styled(DialogTitle)(() => ({
  padding: pxToRem(16),
  position: "relative",
  textAlign: "center",

  button: {
    position: "absolute",
    top: pxToRem(8),
    right: pxToRem(8),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.md_16,
  fontWeight: theme.typography.fw_semibold_600,
  color: theme.palette.text.textPrimary,
}));

export const StepWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: pxToRem(3),
  lineHeight: theme.typography.lineHeight.md,
  fontSize: theme.typography.size.sm_14,
  fontWeight: theme.typography.fw_semibold_500,
  color: theme.palette.text.textPrimary,
  marginBottom: pxToRem(12),
}));

export const TextBlue = styled("span")(({ theme }) => ({
  color: theme.palette.text.textLink,
}));
